import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.min.css'
import './assets/styles/main.scss'
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux'
import store from './store/store'
const root = ReactDOM.createRoot(document.getElementById('root'));
Object.defineProperty(window, 'reduxStore', {
  get() {
    return store.getState();
  },
});
root.render(
  <React.StrictMode>
  <Provider store={store}>
    <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
